module.exports = __webpack_public_path__ + "img/logo2.320142b6.png";